export default {"src":"/_next/static/media/loan-coverage.be220522.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};